'use strict';

import { tns } from 'tiny-slider';

jQuery(document).ready(function () {
    var lazyLoadBackgroundImages = function (info) {
        const $slide = jQuery(info.slideItems[info.index + 1]);
        // direct access to info object
        if ($slide.data('back-src')) {
            var dataSrc = $slide.data('back-src');
            $slide.removeAttr('data-back-src').attr('style', 'background: url("' + dataSrc + '") no-repeat center/cover;');
        }

        if ($slide.find('[data-video-src]').length) {
            var $source = $slide.find('[data-video-src]');
            var videoSrc = $source.data('video-src');
            $source.removeAttr('data-video-src').attr('src', videoSrc);

            var video = $source.closest('video')[0];
            if (video) {
                video.load();
            }
        }
    };

    var slider = tns({
        container: '.slider-container',
        loop: true,
        autoplay: true,
        controls: false,
        mouseDrag: true,
        nav: true,
        navPosition: 'bottom',
        autoplayTimeout: TIMER,
        autoplayButton: false,
        navContainer: '.nav-container',
        onInit: lazyLoadBackgroundImages
    });

    // bind function to event
    slider.events.on('transitionStart', lazyLoadBackgroundImages);

    // Add 'show' class after slider initialization
    jQuery('.slider-container').addClass('show');
    jQuery('.nav-container').addClass('show');
});
